import {
    GET_CUSTOMER_PO_LIST_PROGRESS, GET_CUSTOMER_PO_LIST_SUCCESS, GET_CUSTOMER_PO_LIST_FAILURE,
    ADD_CUSTOMER_PO_PROGRESS, ADD_CUSTOMER_PO_SUCCESS, ADD_CUSTOMER_PO_FAILURE,
    EDIT_DELETE_CUSTOMER_PO_PROGRESS, EDIT_DELETE_CUSTOMER_PO_SUCCESS, EDIT_DELETE_CUSTOMER_PO_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    customer_po: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const customer_po_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_CUSTOMER_PO_LIST_SUCCESS:
            return { ...state, customer_po: action.customer_po, loading: false };
        case GET_CUSTOMER_PO_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CUSTOMER_PO_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_CUSTOMER_PO_PROGRESS:
            return { ...state, loading: true };
        case ADD_CUSTOMER_PO_SUCCESS:
            return { ...state, customer_po: [...state.customer_po, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CUSTOMER_PO_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_CUSTOMER_PO_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CUSTOMER_PO_SUCCESS:
            return {
                ...state,
                customer_po: state.customer_po.map((customer_po) =>
                    customer_po.id === action.payload.id ? action.payload : customer_po
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CUSTOMER_PO_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default customer_po_reducer;